import * as HLF from "html-living-framework";
import * as Constants from "../Data/Constants";
import * as PinataData from "../Data/PinataData";
import * as Topics from "../Data/Topics";
import {Paintable} from "../GameObjects/Paintable";
import {PaintableLayer} from "../GameObjects/PaintableLayer";

export class PaintablePinata extends Paintable implements HLF.Input.IFocusable {
    private static readonly MAX_WIDTH: number = 768;

    private _outline: PIXI.Sprite;
    private _rope?: PIXI.Sprite;

    constructor(pIndex: number, pCreateInput: boolean = true) {
        super(pIndex);

        const sheet: string = Constants.SPRITESHEET_PINATA_PREFIX + HLF.NumberUtils.addZeroPadding(this._index, 2);

        for (let i = 0; i < PinataData.LAYER_DATA[this._index].length; ++i) {
            const index: number = i;
            const layer: PaintableLayer = new PaintableLayer(
                "pinata0" + this._index + "-" + HLF.NumberUtils.addZeroPadding(i, 2),
                sheet,
                // TODO:SH: Look into an alternative to baking in the index like this
                // maybe pass `this` and get index from array?
                () => {
                    this.onLayerPainted(index);
                },
                pCreateInput ? PinataData.HIT_AREAS[this._index] : undefined,
                i,
            );
            layer.paint(PinataData.LAYER_DATA[this._index][i], 0, 0, true, true, true);
            layer.scale.set(4);
            this._layers.push(layer);
            this.addChild(layer);
        }

        if (!pCreateInput) {
            console.warn("using PixelPerfectHitArea for pinata0" + this._index);
        }

        this._outline = HLF.PixiUtils.makeSprite("pinata0" + this._index + "-" + "outline", sheet);
        this.addChild(this._outline);

        const widthPerc: number = this._layers[0].width / PaintablePinata.MAX_WIDTH;
        if (widthPerc > 1) {
            for (let i = 0; i < this._layers.length; ++i) {
                this._layers[i].scale.set(4 * (1 / widthPerc));
            }
            this._outline.scale.set(1 / widthPerc);
        }

        this.on(HLF.Input.Events.TAP, this.onPinataClicked.bind(this));
        this.on(HLF.Input.Events.CLICK, this.onPinataClicked.bind(this));
    }

    public onFocusBegin(): void {
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_BEGIN, this);
    }

    public onFocusActivated(): void {
        if (this.interactive) {
            this.onPinataClicked();
        }
    }

    public onFocusEnd(): void {
        PubSub.publishSync(Topics.KEYBOARD_FOCUS_END, this);
    }

    public getFocusPosition(): PIXI.Point {
        const global: PIXI.Point = this.getGlobalPosition();
        global.y += this.pivot.y * this.getFocusSize().y;
        return global;
    }

    public getFocusSize(): PIXI.Point {
        return new PIXI.Point(this.width, this.height);
    }

    public setInputEnabledPinata(pEnable: boolean): void {
        this.interactive = pEnable;
        this.buttonMode = pEnable;
        PubSub.publishSync(pEnable ? HLF.REGISTER_FOCUSABLE : HLF.UNREGISTER_FOCUSABLE, this);
        PubSub.publishSync(HLF.RE_MAP_KEYBOARD, undefined);
    }

    public addRope() {
        if (!this._rope) {
            this._rope = this.addChildAt(HLF.PixiUtils.makeSprite("rope", "pinata-candy"), 0);
            this._rope.y = -this._rope.height * 0.5;
        } else {
            this._rope.visible = true;
        }
    }

    public hideRope() {
        if (this._rope) {
            this._rope.visible = false;
        }
    }

    protected onPinataClicked(): void {
        console.log("pinata clicked");
        PubSub.publishSync(Topics.PINATA_HIT, this);
    }

}
